import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Map, Overlay } from "pigeon-maps";
import { ListaMaquinasByDistance } from "@/hooks/useMaquinas";
import { homeStore } from "@/_zustand/home";
import { useAuth } from "@/_zustand/auth";
import { useMachine } from "@/_zustand/machine";
import { useMachineNavigation } from "@/hooks/useMachineNavigation";

export function MapComponent() {
  const params = useParams();
  const { goToMachine } = useMachineNavigation();
  const [center, setCenter] = useState([-33.386611, -70.68118225]);
  const [zoom, setZoom] = useState(11);
  const [hue, setHue] = useState(0);
  const { empresa_id } = useMachine();

  const { tiendaId: storeTiendaId } = homeStore();

  // Prioritize URL param, then store state
  const tiendaId = params.tiendaId ? empresa_id : storeTiendaId;
  const { userAddress } = useAuth();
  const latitud = userAddress?.length === 2 ? Number(userAddress[0]) : -33.4369;
  const longitud =
    userAddress?.length === 2 ? Number(userAddress[1]) : -70.6693;
  const {
    data: response,
    isLoading,
    isError,
    refetch,
  } = ListaMaquinasByDistance(latitud, longitud, tiendaId);
  const maquinasResponse = React.useMemo(() => {
    if (response && response.status === "success" && Array.isArray(response.data)) {
      return empresa_id
        ? response.data.filter((machine) => machine.empresa_id == empresa_id)
        : response.data;
    }
    return [];
  }, [response, empresa_id]);

  useEffect(() => {
    refetch();
  }, [latitud, longitud, tiendaId, refetch]);

  useEffect(() => {
    if (maquinasResponse && maquinasResponse.length > 0) {
      // `fitBounds` nunca estuvo definido ni importado (no existe en pigeon-maps
      // ni fue declarado localmente), por lo que esta rama de auto-centrado
      // del mapa nunca se ejecutó desde su implementación original.
    } else if (!maquinasResponse || maquinasResponse.length === 0) {
      // Only reset if not already at default
      setCenter((prev) =>
        prev[0] !== -33.386611 || prev[1] !== -70.68118225
          ? [-33.386611, -70.68118225]
          : prev,
      );
      setZoom((prev) => (prev !== 10 ? 10 : prev));
    }
  }, [maquinasResponse]);

  const machineClick = (machine) => {
    setHue(hue + 20);
    goToMachine(machine.maquina_id);
  };

  // Renderizado condicional basado en el estado de la mutación y los datos
  if (isLoading) {
    return <div>Cargando máquinas para el mapa...</div>;
  }

  // Si la mutación terminó y no hay datos (ej. la tienda no tiene máquinas)
  if (maquinasResponse.length === 0 && isError) {
    return <div>No hay máquinas disponibles.</div>;
  }

  if (tiendaId == 0 && maquinasResponse) {
    return (
      <div style={{ height: "500px", width: "100%" }}>
        <Map
          id="MapStore"
          center={center}
          zoom={zoom}
          onBoundsChanged={({
            center: newManualCenter,
            zoom: newManualZoom,
          }) => {
            setCenter(newManualCenter);
            setZoom(newManualZoom);
          }}
          // Estas props aseguran que el mapa se inicialice con los valores calculados
          defaultZoom={zoom}
          defaultCenter={center}
        >
          {maquinasResponse
            .filter((item) => item.vende_licor === 0)
            .map((item, index) => (
              <Overlay
                key={index}
                anchor={[item.maquina_latitud, item.maquina_longitud]}
                offset={[12, 38]}
              >
                <img
                  src={item.maquinamodelo_icono}
                  width={25}
                  alt="icon"
                  onClick={() => machineClick(item)}
                  style={{ cursor: "pointer" }}
                />
              </Overlay>
            ))}
        </Map>
      </div>
    );
  }

  // Si hay datos, renderiza el mapa
  return (
    <div style={{ height: "500px", width: "100%" }}>
      <Map
        id="MapStore"
        center={center}
        zoom={zoom}
        onBoundsChanged={({ center: newManualCenter, zoom: newManualZoom }) => {
          setCenter(newManualCenter);
          setZoom(newManualZoom);
        }}
        // Estas props aseguran que el mapa se inicialice con los valores calculados
        defaultZoom={zoom}
        defaultCenter={center}
      >
        {maquinasResponse &&
          maquinasResponse
            .filter((item) => item.vende_licor === 0)
            .map((item, index) => (
              <Overlay
                key={index}
                anchor={[item.maquina_latitud, item.maquina_longitud]}
                offset={[12, 38]}
              >
                <img
                  src={item.maquinamodelo_icono}
                  width={25}
                  alt="icon"
                  onClick={() => machineClick(item)}
                  style={{ cursor: "pointer" }}
                />
              </Overlay>
            ))}
      </Map>
    </div>
  );
}
